import { alertVariants } from "@visiblethread/react-components";

import { showGlobalAlert } from "../../app/appSlice";
import { selectSharepoint } from "../selectors";
import { setIsSharepointAuthorized } from "../sharepointSlice";
import {
  OFFICE_DIALOG_ERROR_USER_CLOSED,
  SP_AUTH_FAILED_ERROR_TEXT,
  SP_AUTH_POPUP_ERROR_TEXT,
} from "./constants";
import { hasOfficeDialogApi, isValidAuthUrl } from "./utils";

const openSharepointAuthWindowPopup = (authUrl, dispatch) => {
  const popup = window.open(authUrl, "_blank");

  if (!popup) {
    dispatch(
      showGlobalAlert({
        variant: alertVariants.warning,
        text: SP_AUTH_POPUP_ERROR_TEXT,
      })
    );
    return;
  }

  const onMessage = (event) => {
    if (event.origin !== window.location.origin) {
      return;
    }
    const messageType = event.data?.type;
    if (
      messageType !== "SP_AUTH_COMPLETE" &&
      messageType !== "SP_AUTH_FAILED"
    ) {
      return;
    }

    window.removeEventListener("message", onMessage);

    if (!popup.closed) {
      popup.close();
    }

    if (messageType === "SP_AUTH_FAILED") {
      dispatch(
        showGlobalAlert({
          variant: alertVariants.warning,
          text: SP_AUTH_FAILED_ERROR_TEXT,
        })
      );
      return;
    }

    dispatch(setIsSharepointAuthorized(true));
  };

  window.addEventListener("message", onMessage);
};

const openSharepointAuthOfficeDialog = (authUrl, dispatch) => {
  window.Office.context.ui.displayDialogAsync(
    authUrl,
    { height: 60, width: 40, promptBeforeOpen: false },
    (asyncResult) => {
      if (asyncResult.status === window.Office.AsyncResultStatus.Failed) {
        dispatch(
          showGlobalAlert({
            variant: alertVariants.warning,
            text: SP_AUTH_POPUP_ERROR_TEXT,
          })
        );
        return;
      }

      const dialog = asyncResult.value;

      dialog.addEventHandler(
        window.Office.EventType.DialogMessageReceived,
        (arg) => {
          let message;
          try {
            message = JSON.parse(arg.message);
          } catch {
            return;
          }

          const messageType = message?.type;
          if (
            messageType !== "SP_AUTH_COMPLETE" &&
            messageType !== "SP_AUTH_FAILED"
          ) {
            return;
          }

          dialog.close();

          if (messageType === "SP_AUTH_FAILED") {
            dispatch(
              showGlobalAlert({
                variant: alertVariants.warning,
                text: SP_AUTH_FAILED_ERROR_TEXT,
              })
            );
            return;
          }

          dispatch(setIsSharepointAuthorized(true));
        }
      );

      dialog.addEventHandler(
        window.Office.EventType.DialogEventReceived,
        (arg) => {
          if (arg.error === OFFICE_DIALOG_ERROR_USER_CLOSED) {
            return;
          }

          dispatch(
            showGlobalAlert({
              variant: alertVariants.warning,
              text: SP_AUTH_POPUP_ERROR_TEXT,
            })
          );
        }
      );
    }
  );
};

export const openSharepointAuthPopup = () => (dispatch, getState) => {
  const sharepoint = selectSharepoint(getState());
  const { authUrl } = sharepoint;

  if (!isValidAuthUrl(authUrl)) {
    return;
  }

  if (hasOfficeDialogApi()) {
    openSharepointAuthOfficeDialog(authUrl, dispatch);
    return;
  }

  openSharepointAuthWindowPopup(authUrl, dispatch);
};
